import {userApi} from "../../api/api-wrapper";
import {Context, Router} from "@profiscience/knockout-contrib-router";
import {UserDto} from "../../api/generated";
import {autobind} from "knockout-decorators";
import '../../components/elements/user/edit-user';

class ViewModelContext extends Context {
    user: UserDto;
}

class ViewModel {
    public user: UserDto;

    constructor(ctx: ViewModelContext) {
        this.user = ctx.user;
    }

    @autobind
    public editUserSuccess() {
        return Router.update(`/profile/${this.user.id}`, {
            push: true,
            force: false
        });
    }

    @autobind
    public editUserCancel() {
        return Router.update(`/profile/${this.user.id}`, {
            push: true,
            force: false
        });
    }

}

export default <KnockoutLazyPageDefinition>{
    viewModel: ViewModel,
    template: require('./edit.html'),
    componentName: "editUser",
    loader: (ctx: ViewModelContext) => {
        document.title = `${document.title} - Profil bearbeiten ${ctx.params && ctx.params.id || ''}`;
        return userApi.getUser(ctx.params.id).then((user) => ctx.user = user);
    }
};
